import { getPreviewImagePath } from '../constants/paths';

export function normalizeImagePath(thumbnailUrl, baseId) {
  if (baseId) {
    return getPreviewImagePath('base', baseId);
  }

  if (thumbnailUrl) {
    const match = thumbnailUrl.match(/base\s*\(?(\d+)\)?/i);
    if (match) {
      return getPreviewImagePath('base', match[1]);
    }
  }

  return getPreviewImagePath('base', 1);
}

export function isDataUrl(url) {
  return url && url.startsWith('data:image');
}

export function getPreviewPath(type, id) {
  return getPreviewImagePath(type, id);
}
